import { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import BaseModal from "../components/BaseModal";

interface RejectModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export default function RejectModal({ open, loading, onClose, onConfirm }: RejectModalProps) {
  const [reason, setReason] = useState("");

  // Reset reason whenever the modal closes — covers cases where the parent
  // clears its own state (e.g. onSuccess) without going through onClose.
  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <BaseModal
      open={open}
      title="Invoice rejected"
      loading={loading}
      confirmLabel="Reject"
      confirmDisabled={!reason.trim()}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <Box>
        <Typography fontSize="14px" lineHeight="20px" mb={1.5}>
          Enter rejection reason
        </Typography>
        <TextField
          autoFocus
          fullWidth
          placeholder="Text"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 48,
              borderRadius: "4px",
              "& fieldset": { borderColor: "#CCC" },
            },
          }}
        />
      </Box>
    </BaseModal>
  );
}
